import React from "react";

function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}

type DivProps = React.HTMLAttributes<HTMLDivElement>;

export function EegDockPanelChrome({
  panelKey,
  className,
  children,
  ...rest
}: DivProps & { panelKey?: string }) {
  return (
    <div
      className={cx("eeg-dock-panel-chrome", className)}
      data-eeg-dock-panel={panelKey}
      data-testid="eeg-dock-panel-chrome"
      {...rest}
    >
      {children}
    </div>
  );
}

export function EegDockPanelNote({ className, children, ...rest }: DivProps) {
  return (
    <div
      className={cx("eeg-dock-panel-chrome__note", className)}
      role="note"
      {...rest}
    >
      {children}
    </div>
  );
}

export { EegDockPanelLabeling } from "./EegDockPanelLabeling";
export type { EegDockPanelLabelingProps } from "./EegDockPanelLabeling";

export function EegDockPanelToolbar({ className, children, ...rest }: DivProps) {
  return (
    <div className={cx("eeg-dock-panel-chrome__toolbar", className)} {...rest}>
      {children}
    </div>
  );
}

export function EegDockPanelField({
  label,
  grow,
  className,
  children,
}: {
  label: React.ReactNode;
  grow?: boolean;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <label
      className={cx(
        "eeg-dock-panel-chrome__field",
        grow && "eeg-dock-panel-chrome__field--grow",
        className,
      )}
    >
      <span className="eeg-dock-panel-chrome__field-label">{label}</span>
      {children}
    </label>
  );
}

export function EegDockPanelStatus({ className, children, ...rest }: DivProps) {
  return (
    <div className={cx("eeg-dock-panel-chrome__status", className)} {...rest}>
      {children}
    </div>
  );
}

export function EegDockPanelChip({
  className,
  children,
  ...rest
}: React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={cx("eeg-dock-panel-chrome__chip", className)} {...rest}>
      {children}
    </span>
  );
}

export function EegDockPanelList({ className, children, ...rest }: DivProps) {
  return (
    <div className={cx("eeg-dock-panel-chrome__list", className)} {...rest}>
      {children}
    </div>
  );
}

export function EegDockPanelCard({
  className,
  children,
  ...rest
}: React.HTMLAttributes<HTMLElement>) {
  return (
    <article className={cx("eeg-dock-panel-chrome__card", className)} {...rest}>
      {children}
    </article>
  );
}

export function EegDockPanelActions({ className, children, ...rest }: DivProps) {
  return (
    <div className={cx("eeg-dock-panel-chrome__actions", className)} {...rest}>
      {children}
    </div>
  );
}
